/**
 * Component: Top bar
 * ------------------------------------------------------------------------------
 * Announcement messaging component displayed in a carousel.
 *
 * @namespace announcementSlider
 */
import Swiper from 'swiper/js/swiper.min';

/**
 * DOM selectors.
 */
const selectors = {
  carousel: '[js-announcement-messages="carousel"]',
  slide: '[js-announcement-messages="slide"]',
};

/**
 * Create a new announcement message object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    carousel: document.querySelector(selectors.carousel),
  };

  /**
   * Global variables.
   */
  let announcementSlider = {};

  /**
   * Initialise component.
   */
  function init() {
    if (!nodeSelectors.carousel) {
      return;
    }

    setDefaultState();
  }

  /**
   * Set default state based on screen size.
   */
  function setDefaultState() {
    constructCarousel();
    initCarousel();
  }

  /**
   * Construct Announcement slider.
   */
  function constructCarousel() {
    announcementSlider = new Swiper(selectors.carousel, {
      a11y: {
        enabled: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      cellSelector: selectors.slide,
      centeredSlides: false,
      effect: 'fade',
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      slidesPerView: 1,
      spaceBetween: 16,
      watchSlidesVisibility: false,
    });
  }

  /**
   * Initialise carousel
   */
  function initCarousel() {
    announcementSlider.init();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
